// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const MoneyIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Money/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.167 2.917H5.833c-2.5 0-4.166 1.25-4.166 4.166v5.834c0 2.916 1.666 4.166 4.166 4.166h8.334c2.5 0 4.166-1.25 4.166-4.166V7.083c0-2.916-1.666-4.166-4.166-4.166Zm-8.959 9.166a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625V7.917a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v4.166ZM10 12.5A2.497 2.497 0 0 1 7.5 10c0-1.383 1.117-2.5 2.5-2.5s2.5 1.117 2.5 2.5-1.117 2.5-2.5 2.5Zm6.042-.417a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625V7.917a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v4.166Z"
}));
export default MoneyIcon;